import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=7172c3f4&"
import script from "./IconInfo.vue?vue&type=script&lang=js&"
export * from "./IconInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7172c3f4')) {
      api.createRecord('7172c3f4', component.options)
    } else {
      api.reload('7172c3f4', component.options)
    }
    module.hot.accept("./IconInfo.vue?vue&type=template&id=7172c3f4&", function () {
      api.rerender('7172c3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconInfo.vue"
export default component.exports